import ViewFacility from "./ViewFacility";

export default ViewFacility